import * as React from 'react';

import styled from 'styled-components';
import {useComponent} from '../component-library';
import {DisclaimerReferenceProps} from '../types';

export type TopLineTextPosition = 'left' | 'right';

// TODO: find a better way than negative margins => topLine text should be aligned with the headline

interface ResultProps {
  readonly topLine: string;
  readonly topLineTextPosition: TopLineTextPosition;
  readonly children: React.ReactNode;
  readonly educationalInfo: React.ReactNode;
  readonly disclaimer?: DisclaimerReferenceProps;
  readonly inverted?: boolean;
}

export const Result = ({
  topLine,
  disclaimer,
  educationalInfo,
  inverted = true,
  children,
}: ResultProps): JSX.Element => {
  const Text = useComponent('Text');
  const TextInverted = useComponent('TextInverted');
  const DisclaimerReference = useComponent('DisclaimerReference');

  const TextElement = inverted ? TextInverted : Text;

  return (
    <div>
      <ResultWrapper>
        {disclaimer && (
          <StyledDisclaimerInfo>
            <TextElement variant="headline-very-small" bold tag="h3">
              {topLine}
              <DisclaimerReference {...disclaimer} />
            </TextElement>
            <EducationInfoIcon>{educationalInfo}</EducationInfoIcon>
          </StyledDisclaimerInfo>
        )}
        <StyledContentWrapper>{children}</StyledContentWrapper>
      </ResultWrapper>
    </div>
  );
};

const ResultWrapper = styled.div`
  position: relative;
  padding: ${(props) => props.theme.internal.size.dynamic0100}
    ${(props) => props.theme.internal.size.dynamic0140};

  @media (min-width: ${(props) => props.theme.internal.Breakpoints.b960}px) {
    padding: ${(props) => props.theme.internal.size.dynamic0050}
      ${(props) => props.theme.internal.size.dynamic0100};
  }
`;

ResultWrapper.displayName = 'ResultWrapper';

const StyledContentWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  width: 100%;
  overflow-wrap: anywhere;
  hyphens: auto;
`;

StyledContentWrapper.displayName = 'StyledContentWrapper';

const StyledDisclaimerInfo = styled.div`
  & > h3,
  & > div > h3 {
    display: inline;
    margin: 0;
  }
`;

StyledDisclaimerInfo.displayName = 'StyledDisclaimerInfo';

const EducationInfoIcon = styled.div`
  display: inline-block;
  position: absolute;
  transform: translateY(
    ${(props) => props.theme.brand.spacing.infoIconOffset || 0}
  );
`;
